import React from 'react'
import PropTypes from 'prop-types'
import { Bar } from 'react-chartjs-2'
import styles from './index.module.scss'
import { COLORS } from '../../../utilities/constants'

const GREEN = COLORS?.PRIMARY

function formatUSD (value) {
  const num = Number(value ?? 0)
  return `$${num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
}

export default function AgingBucketsChart ({ agingBuckets, onBarClick }) {
  const periods = agingBuckets.map((bucket) => bucket.period)
  const amounts = agingBuckets.map((bucket) => {
    const val = Number(bucket.amount ?? 0)
    return val === 0 ? null : val
  })

  if (!agingBuckets.length) return null

  const data = {
    labels: periods,
    datasets: [
      {
        label: 'Overdue Amount',
        data: amounts,
        minBarLength: 5,
        backgroundColor: GREEN,
        borderColor: GREEN,
        borderWidth: 1,
        borderRadius: 2,
        maxBarThickness: 60
      }
    ]
  }

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    onClick: (event, elements) => {
      if (elements.length > 0) {
        const el = elements[0]
        const index = el.index ?? el._index
        const bucket = agingBuckets[index]
        if (bucket) {
          onBarClick(bucket)
        }
      }
    },
    layout: {
      padding: { top: 10, bottom: 5, left: 10, right: 10 }
    },
    plugins: {
      legend: {
        display: true,
        position: 'top',
        align: 'start',
        labels: {
          usePointStyle: true,
          pointStyle: 'rect',
          boxWidth: 14,
          boxHeight: 14,
          padding: 8,
          font: { size: 13 }
        }
      },
      tooltip: {
        enabled: true,
        backgroundColor: 'rgba(17, 24, 39, 0.95)',
        titleColor: COLORS.WHITE,
        titleFont: { weight: 'bold', size: 13 },
        bodyColor: COLORS.WHITE,
        bodyFont: { size: 12 },
        padding: 10,
        usePointStyle: true,
        boxWidth: 10,
        boxHeight: 10,
        callbacks: {
          title: (items) => items[0]?.label || '',
          label: (item) => `Overdue Amount: ${formatUSD(item.raw)}`
        }
      }
    },
    scales: {
      x: {
        title: { display: false },
        grid: { display: false },
        ticks: { font: { size: 12 } }
      },
      y: {
        beginAtZero: true,
        grid: { color: COLORS.OFF_WHITE },
        ticks: {
          callback: (value) => formatUSD(value),
          font: { size: 11 }
        }
      }
    }
  }

  return (
    <div className={styles.chart}>
      <div className={styles.bar}>
        <Bar data={data} options={options} />
      </div>
      <p
        className={styles.title}>
        Aging Buckets By Overdue Amount
      </p>
    </div>
  )
}

AgingBucketsChart.propTypes = {
  agingBuckets: PropTypes.arrayOf(
    PropTypes.shape({
      period: PropTypes.string.isRequired,
      status: PropTypes.string.isRequired,
      amount: PropTypes.number
    })
  ).isRequired,
  onBarClick: PropTypes.func.isRequired
}
